






import Vue from "vue";
declare var google: any;
import { Component, Prop, Watch } from "vue-property-decorator";
import ProposalScheduleGanttPhase from "../../models/porposal/proposalScheduleGanttPhase.model";
import ProposalScheduleGanttActivity from "../../models/porposal/ProposalScheduleGanttActivity.model";

@Component({})
export default class GantCharttComponent extends Vue {
  @Prop() public id!: string;
  @Prop() public proposalScheduleGanttPhase!: ProposalScheduleGanttPhase;
  @Prop() public proposalScheduleGanttActivities!: Array<
    ProposalScheduleGanttActivity
  >;

  drawChart() {
    

    let chart = new google.visualization.Gantt(
      document.getElementById(this.id)
    );
      
    let ganttDataTable = new google.visualization.DataTable();
    ganttDataTable.addColumn("string", "Task ID");
    ganttDataTable.addColumn("string", "Task Name");
    ganttDataTable.addColumn("string", "Resource");
    ganttDataTable.addColumn("date", "Start Date");
    ganttDataTable.addColumn("date", "End Date");
    ganttDataTable.addColumn("number", "Duration");
    ganttDataTable.addColumn("number", "Percent Complete");
    ganttDataTable.addColumn("string", "Dependencies");
    
    let phaseStartDate = (typeof this.proposalScheduleGanttPhase.startDate === 'string') ? new Date(this.proposalScheduleGanttPhase.startDate) : this.proposalScheduleGanttPhase.startDate;
    let phaseEndDate = (typeof this.proposalScheduleGanttPhase.endDate === 'string') ? new Date(this.proposalScheduleGanttPhase.endDate) : this.proposalScheduleGanttPhase.endDate;
    let phase = [
      this.proposalScheduleGanttPhase.taskId,
      this.proposalScheduleGanttPhase.taskName,
      this.proposalScheduleGanttPhase.resource,
      phaseStartDate,
      phaseEndDate,
      null,
      this.proposalScheduleGanttPhase.percentDone,
      null
    ];
    ganttDataTable.addRows([phase]);
    this.proposalScheduleGanttActivities.forEach(scheduleGantt => {
      let activityStartDate = (typeof scheduleGantt.startDate === 'string') ? new Date(scheduleGantt.startDate) : scheduleGantt.startDate;
      let activityEndDate = (typeof scheduleGantt.endDate === 'string') ? new Date(scheduleGantt.endDate) : scheduleGantt.endDate;
    
      if (!scheduleGantt.deleted) {
        let percentDone: number = (typeof scheduleGantt.percentDone === 'string') ? Number(scheduleGantt.percentDone) : scheduleGantt.percentDone;
        
        let task = [
          scheduleGantt.taskId,
          `${this.proposalScheduleGanttPhase.taskName} | ${scheduleGantt.taskName}`,
          scheduleGantt.resource,
          activityStartDate,
          activityEndDate,
          null,
          percentDone,
          scheduleGantt.dependencies
        ];
        ganttDataTable.addRows([task]);
      }
    });

    var options = {
      height: null,
      width: 1000,
      gantt: {
        trackHeight: 40,
        //defaultStartDateMillis: new Date(2015, 3, 28),
        criticalPathEnabled: false
      }
    };

    chart.draw(ganttDataTable, options);
  }

  @Watch("proposalScheduleGanttActivities")
  @Watch("proposalScheduleGanttPhase", {immediate: true, deep: true})
  onScheduleChange() {
    
    if (
      this.proposalScheduleGanttActivities ||
      this.proposalScheduleGanttPhase
    ) {
      google.charts.load("current", { packages: ["gantt"] });
      google.charts.setOnLoadCallback(this.drawChart);
    }
  }
}
